import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree, StoreOptions } from 'vuex';
import { Snackbar } from '../model/snackbar';
import { RootState } from './types';
import { instance } from '../backend';
import DateUtil from '@/shared/utils/DateUtils';
import { saveList } from './modules/saveList';
import { article } from './modules/article';
import { articleMarker } from './modules/articleMarker';
import { modelMarker } from './modules/modelMarker';
import { responsible } from './modules/responsible';
import { reportDownload } from './modules/reportDownload';
import { auth } from './modules/auth';

Vue.use(Vuex);

export const actions: ActionTree<State, RootState> = {
  async hideSnackbar({ commit }) {
    commit('setSnackbarVisibility', false);
  },
  setRowsPerPage({ commit }, rows: number) {
    commit('setRowsPerPage', rows);
  },
  /**
   * Load backend API version information.
   * @param commit
   */
  ['load_info']: ({ commit }) => {
    instance.get<any>('/api/auth/info').then((value) => {
      if (value && value.data) {
        commit('set_info', value.data);
      }
    });
  },
};

export const mutations: MutationTree<State> = {
  showError: (s: State, payload: any) => {
    s.snackbarlog.push('  error:' + DateUtil.formatDateTimeISO(new Date()) + payload);
    s.snackbar.show = true;
    s.snackbar.color = 'error';
    s.snackbar.text = payload;
    s.snackbar.duration = 5000;
  },
  showSuccess: (s: State, payload: any) => {
    s.snackbarlog.push('success:' + DateUtil.formatDateTimeISO(new Date()) + payload);
    s.snackbar.show = true;
    s.snackbar.color = 'success';
    s.snackbar.text = payload;
    s.snackbar.duration = 5000;
  },
  setSnackbarError: (s: State, payload: any) => {
    s.snackbarlog.push('  error:' + DateUtil.formatDateTimeISO(new Date()) + payload);
    s.snackbar.show = true;
    s.snackbar.color = 'error';
    s.snackbar.text = payload.message;
    s.snackbar.duration = payload.duration;
  },
  setSnackbarSuccess: (s: State, payload: any) => {
    s.snackbarlog.push('success:' + DateUtil.formatDateTimeISO(new Date()) + payload);
    s.snackbar.show = true;
    s.snackbar.color = 'success';
    s.snackbar.text = payload.message;
    s.snackbar.duration = payload.duration;
  },
  setSnackbarVisibility: (s: State, visibility: boolean) => {
    s.snackbar.show = visibility;
  },
  setRowsPerPage: (s: State, rows: number) => {
    s.pagination.rowsPerPage = rows;
  },
  ['set_info']: (s: State, info: any) => {
    s.apiInfo = info;
  },
  ['set_dateFormat']: (s: State, dateFormat: any) => {
    s.dateFormat = dateFormat;
  },
};

export const getters: GetterTree<State, RootState> = {
  ['info']: (s: State) => s.apiInfo,
  ['frontend_info']: (s: State) => process.env.VERSION || 0,
  ['dateFormat']: (s: State) => s.dateFormat,
};

export interface State {
  apiInfo: string | null;
  pagination: any;
  dateFormat: string;
  snackbar: Snackbar;
  snackbarlog: string[];
}

export const state = (): State => ({
  apiInfo: null,
  snackbar: {
    show: false,
    color: '',
    text: '',
    duration: 5000,
  },
  snackbarlog: [],
  pagination: {
    rowsPerPage: 25,
  },
  dateFormat: 'DD.MM.YYYY',
});

const storeOptions: StoreOptions<RootState> = {
  state: state() as any,
  getters,
  mutations,
  actions,
  modules: {
    article,
    articleMarker,
    auth,
    modelMarker,
    saveList,
    responsible,
    reportDownload,
  },
};
const store = new Vuex.Store<RootState>(storeOptions);

export default store;
